import {
  CopyToClipboardButton,
  Stack,
  Text,
  TextBadge,
  TextBadgeColor,
  TextBadgeSize
} from "@bps/fluent-ui";
import {
  DeviceDetail,
  KnownDeviceProperties
} from "@libs/api/gateways/field/field-ops-gateway.dtos";

export interface DeviceMultipleSiteIdComponentProps {
  device: DeviceDetail;
}

export const DeviceMultipleSiteIdComponent = ({
  device
}: DeviceMultipleSiteIdComponentProps) => {
  if (!device) return null;

  const siteIdProperties = [
    ...new Set(
      device.properties
        .filter(
          x =>
            x.propertyType === KnownDeviceProperties.SiteID && !!x.propertyValue
        )
        .map(x => x.propertyValue!) ?? []
    )
  ];

  const numSiteIds = siteIdProperties.length;
  return (
    <Stack>
      <Stack horizontal verticalAlign="center" wrap>
        {siteIdProperties.map(siteId => {
          return (
            <Stack key={siteId} horizontal verticalAlign="center">
              <CopyToClipboardButton
                clipboardContent={siteId}
                buttonProps={{
                  styles: {
                    root: {
                      height: "20px"
                    }
                  }
                }}
              />
              <Text>{siteId}</Text>
            </Stack>
          );
        })}
      </Stack>{" "}
      {numSiteIds > 1 && (
        <TextBadge
          badgeColor={TextBadgeColor.red}
          badgeSize={TextBadgeSize.small}
          styles={{ root: { width: "fit-content" } }}
        >
          {numSiteIds} site ID's
        </TextBadge>
      )}
    </Stack>
  );
};
